module.exports = {
    en: {
        latest: {
            text: 'Latest Blog Posts',
        }

    },
    ka: {
        latest: {
            text: 'ბლოგის უახლესი პოსტები',
        }
    },
    ru: {
        latest: {
            text: 'Последние записи в блоге',
        }
    }
}